export class TemplateHelperService {
	/*
	* returns the url for the template
	*/
	getTemplateUrl(templateName: string) {

		let url = `/_lumas/templates/${window.$lumasContext.environment == 'online' ? 'online-' : ''}${templateName.replace(/^\//g, '')}?rev=${window.$lumasContext.rev}`;
		return url;
	} 
}